import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-flight-takeoff-line', title: 'İlk Uçuşla Yurt Dışına', desc: 'Operasyon ekibimiz tarafından ilk uçuş ile yurt dışına çıkışınız organize edilir.' },
  { icon: 'ri-timer-flash-line', title: 'Gün İçi Teslim Alım', desc: 'Kuryeleri, gönderilerinizi gün içerisinde bölgeniz için belirlenen en son alım saatinden önce teslim alır.' },
  { icon: 'ri-global-line', title: 'Dünyanın Her Noktasına', desc: 'Türkiye\'den dünyanın her noktasına en hızlı teslimatı gerçekleştiren servis.' },
  { icon: 'ri-shield-check-line', title: 'Sigortalı Taşıma', desc: 'Tüm ekspres gönderileriniz sigorta kapsamında güvence altındadır.' },
  { icon: 'ri-customer-service-2-line', title: '7/24 Destek', desc: 'Uzman ekibimiz her an yanınızda, sorularınızı anında yanıtlıyoruz.' },
  { icon: 'ri-map-pin-2-line', title: 'Anlık Takip', desc: 'Gönderinizi kapıdan kapıya anlık olarak takip edebilirsiniz.' },
];

const steps = [
  { num: '01', title: 'Gönderi Teslim Alımı', desc: 'Kurye ekibimiz gönderinizi adresinizden teslim alır.' },
  { num: '02', title: 'Operasyon Merkezi', desc: 'Gönderiniz operasyon merkezimizde işleme alınır ve ilk uçuşa hazırlanır.' },
  { num: '03', title: 'Uçuş & Transit', desc: 'İlk uygun uçuşla yurt dışına çıkış sağlanır.' },
  { num: '04', title: 'Kapıya Teslimat', desc: 'Varış ülkesinde yerel dağıtım ağımızla alıcıya teslim edilir.' },
];

export default function EkspresKuryePage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=commercial%20cargo%20airplane%20taking%20off%20at%20golden%20hour%2C%20dramatic%20sky%20with%20warm%20orange%20tones%2C%20airport%20runway%20lights%2C%20motion%20blur%20on%20wings%2C%20cinematic%20wide%20angle%20shot%2C%20professional%20aviation%20photography%2C%20deep%20blue%20and%20orange%20color%20palette%2C%20high%20contrast%20dramatic%20lighting&width=1920&height=680&seq=ekspres-hero-01&orientation=landscape"
            alt="Ekspres Kurye"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(10,10,20,0.88) 0%, rgba(15,20,40,0.75) 55%, rgba(10,10,20,0.55) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-24 left-16 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Ekspres Kurye Servisi</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-flight-takeoff-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Ekspres Kurye Servisi</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Türkiye&apos;den Dünyaya<br />
                <span style={{ color: 'var(--orange)' }}>En Hızlı Teslimat</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                CargoNet kuryeleri gönderilerinizi gün içinde teslim alır, operasyon ekibimiz ilk uçuşla yurt dışına çıkışını organize eder. 220+ ülkeye kapıdan kapıya ekspres teslimat.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link
                  to="/iletisim"
                  className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity"
                  style={{ background: 'var(--orange)', textDecoration: 'none' }}
                >
                  <i className="ri-mail-send-line" />
                  Teklif Al
                </Link>
                <a
                  href="tel:+908502420822"

                  className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity"
                  style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}
                >
                  <i className="ri-phone-line" />
                  0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[
                { val: '220+', lbl: 'Ülke' },
                { val: 'Gün İçi', lbl: 'Teslim Alım' },
                { val: 'İlk', lbl: 'Uçuşla Çıkış' },
                { val: '7/24', lbl: 'Destek' },
              ].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-20" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Nasıl Çalışır?</h2>
            <p className="text-sm" style={{ color: 'var(--text3)' }}>Gönderiniz 4 adımda dünyanın her yerine ulaşır.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <div key={i} className="relative p-6 rounded-2xl" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                <div className="text-4xl font-black mb-4" style={{ color: 'rgba(232,97,26,0.15)' }}>{s.num}</div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{s.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{s.desc}</p>
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-6 flex items-center justify-center z-10">
                    <i className="ri-arrow-right-s-line text-lg" style={{ color: 'var(--orange)' }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features + Image */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Neden CargoNet Ekspres?</h2>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Yurtdışı uçak kargo göndericilerinin en çok tercih ettiği servis. Gün içi teslim alım, ilk uçuşla çıkış ve 220+ ülkeye kapıdan kapıya teslimat.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[260px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=logistics%20worker%20scanning%20packages%20in%20modern%20cargo%20sorting%20facility%2C%20conveyor%20belts%20with%20parcels%2C%20bright%20warehouse%20interior%2C%20orange%20accent%20lighting%2C%20professional%20operations%2C%20clean%20industrial%20environment%2C%20high%20resolution%20photography&width=420&height=260&seq=ekspres-content-01&orientation=landscape"
                alt="Ekspres operasyon"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative overflow-hidden" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Ekspres Gönderiniz İçin Hemen Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Uzman ekibimiz en uygun fiyat ve en hızlı çözümü sizin için hazırlasın.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
